import { ProjectDataflowModel } from '../../../services/ProjectService';
import moment from 'moment';
import { LogsComponent } from './LogsComponent';
import { Trans } from 'react-i18next';
import { Link } from 'react-router-dom';

interface ExportSectionProps {
  exportData: ProjectDataflowModel | undefined;
  showHistoryButton?: boolean; // New prop to control button visibility
  fromList? : boolean; // New prop to control the title
  style?: React.CSSProperties;

}

export function ExportSection({ exportData, showHistoryButton = true , fromList= false, style}: ExportSectionProps) {

  return (
    <>
      <div className="border rounded tile-content p-3 m-4 d-flex flex-column gap-2" style={style}>
        <div className="d-flex justify-content-between align-items-center mb-2">
        <h5 className="title">            
          {fromList ? (<Trans>configuration.projects.dataExport</Trans>) : (<Trans>configuration.projects.lastDataExport</Trans>)}
        </h5>
        {showHistoryButton && ( // Conditionally render the button
            <Link to="/project/projectExportHistory" className="btn btn-primary"><Trans>configuration.projects.processHistory</Trans></Link>
        )}
        </div>
        {exportData ? (
        <>
          <p className='pt-2'> <b><Trans>general.status</Trans>:</b> {exportData.Status && <Trans>{`general.${exportData.Status}`}</Trans>} </p>
          <p className='pt-2'> <b><Trans>general.start</Trans>:</b> {moment(exportData.StartDate).format("YYYY-MM-DD HH:mm:ss")}</p>
          <p> <b><Trans>general.end</Trans>:</b> {moment(exportData.EndDate).format("YYYY-MM-DD HH:mm:ss")}</p>
        </>
        ) : (
          <p><Trans>configuration.projects.noExportDataAvailable</Trans></p>
        )}
          {exportData && exportData.Details && exportData.Details.length > 0 && (
          <LogsComponent logs={exportData.Details.flatMap(detail => detail.Logs || [])} />
        )}
      </div>
    </>
    
  );
}
